export default function SupportPercentChoice({ value, onChange, label, disabled = false, allowNone = false }) {
  return <label className="block font-semibold">{label}
    <select className="mt-2 block w-full min-h-12 rounded border border-slate-300 bg-white p-3 text-slate-900"
      value={value ?? ""} disabled={disabled} onChange={(event) => onChange(event.target.value ? Number(event.target.value) : null)}>
      <option value="">Not sure / prefer to discuss</option>
      {allowNone && <option value="0">0% · no support received</option>}
      {Array.from({ length: 10 }, (_, index) => (index + 1) * 10).map((percent) =>
        <option key={percent} value={percent}>{percent}%{percent === 10 ? " · a little support" : percent === 100 ? " · step-by-step support throughout" : ""}</option>)}
    </select>
    <span className="mt-2 block text-sm font-normal">This is how it feels to you. It is separate from your learning percentage, challenge level and proven skills.</span>
  </label>;
}
